<template>
  <v-card class="mini-weather-card teal darken-4 white--text mr-5 pa-2 align-center mini-weather-card" v-show="$route.name !== 'home'">
    <span v-show="isLoading">
      <v-icon class="white--text">
        mdi-loading mdi-spin mdi-light
      </v-icon>
    </span>
    <v-spacer></v-spacer>
    <div class="d-inline-flex align-center mr-2" v-if="warning !== undefined">
      <img v-for="w in warning" :src="require(`@/assets/warning/${w.code.toLowerCase()}.png`)" :alt="w.name" :key="w.code" width="24">
    </div>
    <img v-for="w in weatherIconArray" :src="weatherIconPath(w)" alt="weather icon" height="24" width="24">
    <span class="local-temperature mx-2" v-if="localTemperature !== undefined">
      {{ localTemperature.place }} {{ localTemperature.value }}°C
    </span>
    <v-icon @click="resetInterval">
      mdi-refresh mdi-light
    </v-icon>
  </v-card>
</template>

<script>
export default {
  data(){
    return ({
      intervalVar: 0,
    })
  },
  computed: {
    isLoading(){
      return this.$store.state.weatherReport.isLoading && this.$store.state.warning.isLoading;
    },
    localTemperature(){
      var temp = {};
      temp = this.temperatureArray.filter(current=>current.place === this.$store.state.settings.location)[0]
      return temp
    },
    warning(){
      return this.$store.state.warning.warningArray;
    },
    refreshInterval(){
      return this.$store.state.settings.refreshInterval;
    },
    temperatureArray(){
      return this.$store.state.weatherReport.temperatureArray;
    },
    weatherIconArray(){
      return this.$store.state.weatherReport.weatherIconArray;
    }
  },
  watch: {
    refreshInterval(){
      this.resetInterval();
    }
  },
  methods: {
    fetchWeatherReport(){
      this.$store.dispatch('fetchWeatherReport')
    },
    fetchWarning(){
      this.$store.dispatch('fetchWarning')
    },
    fetchAll(){
      this.fetchWeatherReport();
      this.fetchWarning();
    },
    autoRefresh(){
      this.fetchAll();
      this.intervalVar = setInterval(()=>this.fetchAll(), this.refreshInterval);
    },
    resetInterval(){
      clearInterval(this.intervalVar);
      this.autoRefresh();
    },

    weatherIconPath(icon){
      return require('@/assets/weather-icons/icon-' + icon + '.png');
    }
  },
  created(){
    this.autoRefresh();
  }
}
</script>

<style lang="scss">
.mini-weather-card {
  min-width: 300px;
  min-height: 42px;
}
.mini-weather-card.v-card{
  display: flex;
}
</style>
